export const NavbarItems = [
  {
    title: 'My Appointments',
    url: 'appointment',
    className: '',
  },
  {
    title: 'Login',
    url: 'login',
    className: '',
  },
  {
    title: 'Signup',
    url: 'signup',
    className: '',
  },
  {
    title: 'Prescriptions',
    url: '/prescriptions/list',
    className: '',
  },
  {
    title: 'Appointments',
    url: '/appointment/upcoming',
    className: '',
  },
]
